import { render, staticRenderFns } from "./publish-success.vue?vue&type=template&id=919efac6&scoped=true"
import script from "./publish-success.vue?vue&type=script&lang=js"
export * from "./publish-success.vue?vue&type=script&lang=js"
import style0 from "./publish-success.vue?vue&type=style&index=0&id=919efac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919efac6",
  null
  
)

export default component.exports